import { z } from 'zod'

// null if the location wasn't able to be acquired
// see frontend location.ts
export const RImportResultLocation = z.nullable(z.string())
export type ImportResultLocation = z.infer<typeof RImportResultLocation>
